import React, { useEffect, useState } from 'react';
import { CloseButton, Paper, Text, TextInput, UnstyledButton } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';

const TYPE_LABEL = { gemeente: 'Gemeente', buurt: 'Buurt', project: 'Station', adres: 'Adres' };

// Context onder het resultaat: bij een station de buurt + gemeente, bij een
// buurt de gemeente — zodat gelijknamige resultaten te onderscheiden zijn.
function contextRegel(result) {
  const p = result.feature?.properties || {};
  if (result.type === 'project') {
    return [p.buurtnaam, p.gemeente || p.gemeentenaam].filter(Boolean).join(' · ');
  }
  if (result.type === 'buurt') {
    return p.gemeentenaam || '';
  }
  return '';
}

export default function SearchBar({ showSearchResults, searchResults, onResultSelect, onSearch, onClear }) {
  const [term, setTerm] = useState('');
  const [debounced] = useDebouncedValue(term, 300);

  // Zoeken zodra de (vertraagde) term wijzigt — niet bij elke toetsaanslag.
  useEffect(() => {
    if (onSearch) onSearch(debounced);
  }, [debounced, onSearch]);

  const wis = () => {
    setTerm('');
    if (onClear) onClear();
  };

  return (
    <div style={{ position: 'absolute', top: 12, left: 76, width: 'min(320px, calc(100vw - 152px))', zIndex: 10 }}>
      <TextInput
        placeholder="Zoek station, buurt, gemeente of adres..."
        value={term}
        onChange={e => setTerm(e.currentTarget.value)}
        radius="xl"
        size="md"
        rightSection={term ? <CloseButton onClick={wis} aria-label="Wissen" /> : null}
        styles={{ input: { boxShadow: '0 2px 12px rgba(0,0,0,0.08)' } }}
      />
      {showSearchResults && (
        <Paper mt={6} shadow="md" radius="md" withBorder p={4} style={{ maxHeight: 320, overflowY: 'auto' }}>
          {searchResults.length === 0 ? (
            <Text size="sm" c="dimmed" p="sm">Geen resultaten</Text>
          ) : (
            searchResults.map(result => (
              <UnstyledButton
                key={`${result.type}-${result.id}`}
                onClick={() => { onResultSelect(result); wis(); }}
                style={{ display: 'block', width: '100%', padding: '8px 10px', borderRadius: 6 }}
                className="zoek-resultaat"
              >
                <Text size="sm" fw={500}>{result.name}</Text>
                <Text size="xs" c="dimmed">
                  {TYPE_LABEL[result.type] || result.type}
                  {contextRegel(result) ? ` — ${contextRegel(result)}` : ''}
                </Text>
              </UnstyledButton>
            ))
          )}
        </Paper>
      )}
    </div>
  );
}
